import { Record } from "immutable"

const RESET = "watchdog/RESET"
const SUBMIT_REQUEST = "watchdog/SUBMIT_REQUEST"
const SUBMIT_SUCCESS = "watchdog/SUBMIT_SUCCESS"
const SUBMIT_FAILURE = "watchdog/SUBMIT_FAILURE"
const CHECK_SUCCESS = "watchdog/CHECK_SUCCESS"
const CHECK_FAILURE = "watchdog/CHECK_FAILURE"
const DEACTIVATE_SUCCESS = "watchdog/DEACTIVATE_SUCCESS"
const SET_EMAIL = "watchdog/SET_EMAIL"
const SET_ERROR = "watchdog/SET_ERROR"
const SET_QUERY_CONFIRM = "watchdog/SET_QUERY_CONFIRM"
const SET_ALERTTYPE = "watchdog/SET_ALERTTYPE"
const SET_INTERVAL = "watchdog/SET_INTERVAL"
const SET_VERSION = "watchdog/SET_VERSION"
const SET_BEST_PRICE = "watchdog/SET_BEST_PRICE"
const RESET_CODE = "watchdog/RESET_CODE"

export type WatchdogType = Record<{
  success: boolean,
  loading: boolean,
  error: ?string,
  email: ?string,
  alertType: ?string,
  interval: ?string,
  code: ?string,
  confirmedMail: boolean,
  version: ?string,
  bestPrice: ?number,
}>

const WatchdogState = Record({
  success: false,
  loading: false,
  error: null,
  deactivateSuccess: false,
  queryConfirm: false,
  email: null,
  alertType: "email",
  interval: null,
  code: null,
  status: null,
  confirmedMail: false,
  version: "PAItinerary",
  bestPrice: null,
})

export default function watchdogReducer(state = new WatchdogState(), action) {
  if (!(state instanceof WatchdogState)) return new WatchdogState(state)

  switch (action.type) {
    case RESET:
      return state
        .set("success", false)
        .set("loading", false)
        .set("error", null)
        .set("deactivateSuccess", false)
        .set("queryConfirm", false)

    case SET_EMAIL:
      return state.set("email", action.email).set("confirmedMail", false)

    case SET_ERROR:
      return state.set("error", action.error)

    case SET_QUERY_CONFIRM:
      return state.set("queryConfirm", true)

    case SET_ALERTTYPE:
      return state.set("alertType", action.alertType)

    case SET_INTERVAL:
      return state.set("interval", action.interval)

    case SET_VERSION:
      return state.set("version", action.version)

    case SET_BEST_PRICE:
      return state.set("bestPrice", action.bestPrice)

    case SUBMIT_REQUEST:
      return state
        .set("success", false)
        .set("loading", true)
        .set("error", null)

    case SUBMIT_SUCCESS:
      return state
        .set("success", true)
        .set("loading", false)
        .set("error", null)
        .set("status", action.res.status)
        .set("confirmedMail", action.res.confirmed)

    case SUBMIT_FAILURE:
      return state
        .set("success", false)
        .set("loading", false)
        .set("error", action.error || "Unknown error") // not to get false negatives

    case CHECK_SUCCESS:
      return state.set("interval", action.res.interval).set("code", action.res.code)

    case CHECK_FAILURE:
      return state
        .set("interval", null)
        .set("code", null)
        .set("error", action.error || "Unknown error")

    case DEACTIVATE_SUCCESS:
      return state
        .set("interval", null)
        .set("code", null)
        .set("error", null)
        .set("deactivateSuccess", true)

    case RESET_CODE:
      return state.set("code", null).set("interval", null)

    default:
      return state
  }
}
